// exaustores.jsx
// Configuração dos exaustores

export const exaustoresConfig = [
  { 
    id: "exaustor01", 
    modulo: "7", 
    idx: "5", 
    descricao: "Exaustor APS Final 1"
  },
  { 
    id: "exaustor02", 
    modulo: "7",  
    idx: "6", 
    descricao: "Exaustor APS Final 2"
  },
  { 
    id: "exaustor03", 
    modulo: "7", 
    idx: "7", 
    descricao: "Exaustor APS Final 3"
  },
  { 
    id: "exaustor04", 
    modulo: "7", 
    idx: "8", 
    descricao: "Exaustor APS Final 4"
  },
  { 
    id: "exaustor05", 
    modulo: "8", 
    idx: "1", 
    descricao: "Exaustor APS Final 5"
  },
  { 
    id: "exaustor06", 
    modulo: "8", 
    idx: "2", 
    descricao: "Exaustor APS Final 6"
  },
    { 
    id: "exaustor07", 
    modulo: "8", 
    idx: "3", 
    descricao: "Exaustor APS Final 7"
  },
    { 
    id: "exaustor08", 
    modulo: "8", 
    idx: "4", 
    descricao: "Exaustor APS Final 8"
  }
];

// Função útil para obter informações de ON/OFF para cada exaustor
export const getExaustorOnOffValues = (exaustorId) => {
  const exaustor = exaustoresConfig.find(ex => ex.id === exaustorId || ex.descricao === exaustorId);
  if (!exaustor) {
    return null;
  }
  
  return {
    descricao: exaustor.descricao,
    onValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "OFF" })
  };
};